import * as React from 'react'
import { Link, Route, RouteComponentProps, Switch } from 'react-router-dom'
import RiderProfileCreatePane from '../../containers/riders/RiderProfileCreatePane'
import RiderProfileEditPane from '../../containers/riders/RiderProfileEditPane'
import RidersTablePane from '../../containers/riders/RidersTablePane'
import RiderProfilePane from '../../containers/riders/RiderProfilePane'
import ErrorBoundary from '../ErrorBoundary'

interface IRidersPaneProps {
  currentOrgId: string
  match: any
}
const RidersPane = (props: IRidersPaneProps): any => {
  return (
    <ErrorBoundary>
      <section>
        <div className='bg-white'>
          <Switch>
            <Route path={`${props.match.path}/create`} component={RiderProfileCreatePane} />
            <Route path={`${props.match.path}/:id/profile/`} component={RiderProfilePane} />
            <Route path={`${props.match.path}/:id/edit/`} component={RiderProfileEditPane} />
            <Route path={props.match.path} component={RidersTablePane} />
          </Switch>
        </div>
      </section>
    </ErrorBoundary>
  )
}

export default RidersPane



// WEBPACK FOOTER //
// ./src/components/riders/RidersPane.tsx